const url = {
    protocol: window.location.protocol,
    hostname: window.location.hostname,
    host: window.location.host,
    port: window.location.port
}

export default url
